module.exports = __webpack_public_path__ + "static/ourreach_map-ca70a3ef08610e790e407179a52d1c75.svg";